import React from 'react';
import styles from './sellerpagecustomermanageblock2.module.css';
// import productImage from './path/to/profileImage.png'; // Thay anh san pham vao
import ImageWithFallback from '../ImageWithFallback';

const CustomerDetail = () => {
  const customer = {
    name: 'Nguyễn Văn A',
    address: 'Tỉnh Thừa Thiên Huế, huyện AAA, xã BBB',
    membershipDuration: 'Đã trở thành khách hàng trong 4 tháng',
    spend: '300 000 đ',
    orders: '3 đơn',
    recentOrder: {
      id: '#1001',
      date: '05/08/2024 vào lúc 9 giờ',
      product: {
        name: 'Áo nam',
        color: 'Trắng',
        size: 'XL',
        quantity: 1,
        price: '95 000 đ',
        image: 'profileImage.png',
      },
    },
    contact: {
      email: 'aaa@gmail.com',
      phone: '0326501179',
    },
  };

  return (
    <div className={styles.customerDetail}>
      <div className={styles.header}>
        <button className={styles.backButton}>&lt;</button>
        <div>
          <h2>{customer.name}</h2>
          <p>{customer.address}</p>
          <p>{customer.membershipDuration}</p>
        </div>
        <button className={styles.navigationButton}>&lt;</button>
        <button className={styles.navigationButton}>&gt;</button>
      </div>
      <div className={styles.summary}>
        <div className={styles.timeFilter}>
          <p>Tất cả thời gian</p>
        </div>
        <div className={styles.spend}>
          <p>Số tiền chi tiêu</p>
          <p>{customer.spend}</p>
        </div>
        <div className={styles.orders}>
          <p>Số đơn hàng</p>
          <p>{customer.orders}</p>
        </div>
      </div>
      <div className={styles.latestOrder}>
        <h3>Thông tin đơn hàng mới nhất</h3>
        <div className={styles.orderDetails}>
          <div className={styles.orderHeader}>
            <p>{customer.recentOrder.id} (mã đơn hàng)</p>
            <p>{customer.recentOrder.date}</p>
          </div>
          <div className={styles.productDetails}>
            <ImageWithFallback loading="lazy" src={customer.recentOrder.product.image} alt={customer.recentOrder.product.name} />
            <div>
              <p>{customer.recentOrder.product.name}</p>
              <p>Màu: {customer.recentOrder.product.color}</p>
              <p>Size: {customer.recentOrder.product.size}</p>
            </div>
            <div className={styles.quantityPrice}>
              <p>x {customer.recentOrder.product.quantity}</p>
              <p>{customer.recentOrder.product.price}</p>
            </div>
          </div>
          <button className={styles.viewAllOrdersButton}>Xem tất cả đơn hàng</button>
        </div>
      </div>
      <div className={styles.contactInfo}>
        <h3>Thông tin người dùng</h3>
        <p>Thông tin liên lạc</p>
        <p>{customer.contact.email}</p>
        <p>{customer.contact.phone}</p>
      </div>
    </div>
  );
};

export default CustomerDetail;
